import {
  Navigate,
  Route,
  Routes,
  BrowserRouter
} from "react-router-dom";
import { useEffect } from "react";
import Login from './components/sign_up_login/Login';
import SignUp from './components/sign_up_login/SignUp';
import Home from './components/home/Home';
import Form1 from './components/Form/Form1';
import Permutations from './components/Form/Permutation';
import Form2 from './components/Form/Form2';
import { useState } from "react";
import ManageUsers from './components/manageUser';
import ResetPassword from './components/resetPassword';
import DeleteAccount from './components/DeleteAccount';
import Form3 from './components/Form/Form3';
import PaymentSuccess from './components/Form/PaymentSuccess';
import CreateApiKey from "./components/CreateApiKey";
import CategoryGuidelines from "./components/Form/CategoryGuidelines";
import ClientStudyGuide from "./components/Form/ClientStudyGuide";
import ProtectedRoute from './components/ProtectedRoute';
import { initializeAuthService } from './services/authService';
import CryptoPortal from './components/crypto/CryptoPortal';


function App() {
  const [userId, setUserId] = useState('')
  const getId = (id) => {
    setUserId(id)
  }

  // Initialize token refresh service on app load
  useEffect(() => {
    initializeAuthService();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/form1" element={<ProtectedRoute><Form1 getId={getId} /></ProtectedRoute>} />
        <Route path="/form2" element={<ProtectedRoute><Form2 userId={userId}/></ProtectedRoute>} />
        <Route path="/form3" element={<ProtectedRoute><Form3 userId={userId}/></ProtectedRoute>} />
        <Route path="/permutations" element={<ProtectedRoute><Permutations userId={userId}/></ProtectedRoute>} />
        <Route path="/login" element={<Login />} />
        <Route path="/usdc" element={<CryptoPortal />} />
        <Route path="/crypto" element={<Navigate to="/usdc" replace />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/manageUser" element={<ProtectedRoute><ManageUsers /></ProtectedRoute>} />
        <Route path="/resetPassword" element={<ResetPassword />} />
        <Route path="/deleteAccount" element={<DeleteAccount />} />
        <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/createApiKey" element={<ProtectedRoute><CreateApiKey /></ProtectedRoute>} />
        <Route path="/userFeatures-guidelines" element={<CategoryGuidelines />} />
        <Route path="/client-study-guide" element={<ClientStudyGuide />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
